module.exports = __webpack_public_path__ + "static/profile_vj-ceb167b03fce36fe66ac504fd895b5a8.png";